function percentile(sorted, p) {
  if (sorted.length === 0) return 0;
  const idx = Math.min(sorted.length - 1, Math.ceil((p / 100) * sorted.length) - 1);
  return sorted[idx];
}

export function summarizeWebsocketSamples(samples, reconnects) {
  if (samples.length === 0) {
    return {
      count: 0, minMs: 0, maxMs: 0, meanMs: 0,
      p50Ms: 0, p95Ms: 0, p99Ms: 0,
      reconnects
    };
  }
  const sorted = [...samples].sort((a, b) => a - b);
  return {
    count: samples.length,
    minMs: sorted[0],
    maxMs: sorted[sorted.length - 1],
    meanMs: samples.reduce((a, b) => a + b, 0) / samples.length,
    p50Ms: percentile(sorted, 50),
    p95Ms: percentile(sorted, 95),
    p99Ms: percentile(sorted, 99),
    reconnects
  };
}

export function runWebsocketNotifier({
  wsUrl,
  durationMs,
  pingIntervalMs = 2000,
  WebSocketImpl = WebSocket,
  onSample
}) {
  return new Promise(resolve => {
    const samples = [];
    let reconnects = -1; // first connect counts as 0 reconnects
    let pendingPings = new Map();
    let timer = null;
    let stopped = false;
    let ws = null;

    const finish = () => {
      stopped = true;
      if (timer) clearInterval(timer);
      try { ws?.close(); } catch {}
      resolve(summarizeWebsocketSamples(samples, Math.max(0, reconnects)));
    };

    const connect = () => {
      reconnects += 1;
      ws = new WebSocketImpl(wsUrl);
      ws.binaryType = 'arraybuffer';

      ws.addEventListener('open', () => {
        if (stopped) return;
        timer = setInterval(() => {
          if (stopped || ws.readyState !== WebSocketImpl.OPEN) return;
          const t = Date.now();
          pendingPings.set(t, t);
          ws.send(JSON.stringify({ type: 'ping', client_t: t }));
        }, pingIntervalMs);
      });

      ws.addEventListener('message', e => {
        let parsed;
        try { parsed = JSON.parse(typeof e.data === 'string' ? e.data : ''); } catch { return; }
        if (parsed?.type === 'pong' && pendingPings.has(parsed.client_t)) {
          const sentAt = pendingPings.get(parsed.client_t);
          pendingPings.delete(parsed.client_t);
          const rtt = Date.now() - sentAt;
          samples.push(rtt);
          if (onSample) onSample(rtt);
        }
      });

      ws.addEventListener('close', () => {
        if (stopped) return;
        if (timer) { clearInterval(timer); timer = null; }
        // Reconnect after a short backoff if we still have time left.
        setTimeout(() => { if (!stopped) connect(); }, 500);
      });

      ws.addEventListener('error', () => {
        // Errors are followed by 'close' which handles reconnect; nothing to do here.
      });
    };

    setTimeout(finish, durationMs);
    connect();
  });
}
